import React, { useEffect, useState,useRef } from "react";
import useRequest from "@/utils/useRequest";
import { Modal } from "antd";

export const initialData = {
    pagination: {
        total: 0,
        current: 1,
        pageSize: 10
    },
    filters: {},
    sorter: null,
}

const UseWscTableList = ({ appid,url,initParams}) => {
    const mounted = useRef();
    const { request } = useRequest();
    const [isLoading,setLoading] = useState(true);
    const [pagination,setPagination] = useState(initParams?initParams.pagination:initialData.pagination);
    const { current,pageSize } = pagination;
    const [filters,setFilter] = useState(initParams?initParams.filters:initialData.filters);
    const [sorter,setSorter] = useState(initParams?initParams.sorter:initialData.sorter);
    const [list, setList] = useState([]);
    //初始化加载默认列表
    useEffect(() => {
        mounted.current = true;
        Refresh();
        return () => {
            mounted.current = false;
        }
    }, [current,pageSize,JSON.stringify(filters),JSON.stringify(sorter)]);

    const GetList = async (url,params) => {
        setLoading(true);
        try {
            const result = await request(url, "POST", "json", { pagination: params.pagination, filters: params.filters, sorter: params.sorter }, appid);
            setLoading(false);
            return result;
        } catch(err) {
            Modal.error({content:err.message});
        }
    };
    
    //更新数据
    const Refresh = async () => {

        let _params = { pagination, filters, sorter };
        console.log("刷新查询:",_params);
        let result = await GetList(url,_params);
        if (mounted.current) {
            if (result.success) {
                setList(result.data);
                setPagination({
                    ..._params.pagination,
                    total: result.total,
                    current: result.current
                });
            }

        }
    }
    //跳转
    const setPage = async (pageIndex) => {
        setPagination({ ...pagination, current: pageIndex });
    }

    const setPageSize = (size) => {
        setPagination({
            ...pagination,
            pageSize: size,
        });
    }

    const updatePagination = (newPagination) => {
        setPagination({...pagination, ...newPagination});
    }

    return { list, setPage, setPageSize, updatePagination, setFilter, filters, setSorter, pagination, Refresh, isLoading }
}

export default UseWscTableList;